
    const domain = window.location.origin;
    const API_JAVA = `${domain}`;
   const API_PKI = "https://pki.gov.kz/";


      // const API_JAVA = "http://192.168.63.12:8080/sdk-user";
      // const API_JAVA = "http://localhost:8085";
      // const API_PKI = "https://pki.gov.kz";

   // const API_PKI = "http://localhost/new_www";

   export {API_JAVA, API_PKI};


